const dictree = require('./lib/dictree');
const dictreeFlatten = require('./lib/dictree-flatten');

module.exports = {
    ...dictree, ...dictreeFlatten
};